import SFullPage from './style.module.scss';
import { WebPNextImage as Image } from '@/components/WebPImage';
import FadeIn from '@/components/commonComponents/fadeIn';

const FullPageFeature = ({ data }) => {
  return (
    <div className={SFullPage['section']}>
      <FadeIn>
        <div className={SFullPage['title']}>{data.title}</div>
      </FadeIn>
      <FadeIn cascade>
        <div className={SFullPage['container']}>
          {data.items.map((item, index) => (
            <div className={SFullPage['feature-item']} key={index}>
              <div className={SFullPage['feature-img']}>
                <Image src={item.picUrl} alt={item.title} layout="fill" />
              </div>
              <div className={SFullPage['item-title']}>{item.title}</div>
            </div>
          ))}
        </div>
      </FadeIn>
    </div>
  );
};

export default FullPageFeature;
